export { default } from './page/_index.tsx';
import type { MetaFunction } from '@remix-run/node';
import { json, LinksFunction } from '@remix-run/node';
import { externalAction, externalLoader } from '~/utils/externalLoader.server';
export const action = externalAction;
export const loader = externalLoader;
import { useTranslation } from 'react-i18next';

export const meta: MetaFunction = ({ data }: any) => {
	let { t } = useTranslation(['network']);
	let lang = data.userLanguage === 'de' ? '' : data.userLanguage + '/';

	return [
		{
			title: t('routeTitle'),
		},
		{
			name: 'title',
			content: t('routeTitle'),
		},
		{
			property: 'og:title',
			content: t('routeTitle'),
		},
		{
			name: 'twitter:title',
			content: t('routeTitle'),
		},

		{
			name: 'description',
			content: t('routeOther'),
		},
		{
			name: 'og:description',
			content: t('routeOther'),
		},
		{
			name: 'twitter:description',
			content: t('routeOther'),
		},
		{
			property: 'og:url',
			content: 'https://northrock.software/' + lang + 'network/',
		},
		{
			name: 'twitter:url',
			content: 'https://northrock.software/' + lang + 'network/',
		},
	];
};

//* reviews
// import ihk from '~/content/images/network/ihk.png';
import afc from '~/content/images/network/afc.png';
import ihk_klima from '~/content/images/network/ihk_klima.webp';
import hodt from '~/content/images/network/hodt.webp';
import sortlist from '~/content/images/network/sortlist.svg';
import sortlist_dark from '~/content/images/network/sortlist_dark.webp';
import kompaki from '~/content/images/network/KompAKI_1.webp';

//* partner
import cortina from '~/content/images/network/cortina_consult.svg';
// import cortina_dark from '~/content/images/network/cortina_consult_logo_dark.svg';
// import record from '~/content/images/network/record_evolution.webp';
import ironflock from '~/content/images/network/ironFlock.webp';
// import record_dark from '~/content/images/network/record-evolution_dark.webp';
import diveinn from '~/content/images/network/diveinn.webp';
import esa_bic from '~/content/images/network/ESA_BIC_Hessen_DS.webp';
// import esa_bic_dark from '~/content/images/network/ESA_BIC_Hessen_WT.webp';

import ambersearch from '~/content/images/network/ambersearch.webp';
import ambersearch_dark from '~/content/images/network/ambersearch_dark.webp';
import pickware from '~/content/images/network/pickware.webp';
import efes from '~/content/images/network/efpluses.webp';
import magicline from '~/content/images/network/magicline.webp';
import magicline_dark from '~/content/images/network/magicline_dark.webp';
import create_next from '~/content/images/network/createNext.svg';

//* certificates
import cortina_zert from '~/content/images/network/cortina_zert.webp';
// import cortina_zert_web from '~/content/images/network/cortina_zert_web.png';
// import green from '~/content/images/network/green.svg';
// import sortlist from "~/content/images/network/sortlist.svg";
import gi from '~/content/images/network/gi.png';

export const links: LinksFunction = () => {
	return [
		// {
		//   rel: 'canonical',
		//   href: 'https://northrock.software/network',
		// },
		{
			rel: 'preload',
			href: kompaki,
			as: 'image',
		},
		{
			rel: 'preload',
			href: hodt,
			as: 'image',
		},
		{
			rel: 'preload',
			href: afc,
			as: 'image',
		},
		{
			rel: 'preload',
			href: sortlist,
			as: 'image',
		},
		{
			rel: 'preload',
			href: sortlist_dark,
			as: 'image',
		},
		{
			rel: 'preload',
			href: gi,
			as: 'image',
		},
		{
			rel: 'preload',
			href: ihk_klima,
			as: 'image',
		},
		{
			rel: 'preload',
			href: cortina,
			as: 'image',
		},
		{
			rel: 'preload',
			href: diveinn,
			as: 'image',
		},
		{
			rel: 'preload',
			href: ironflock,
			as: 'image',
		},

		{
			rel: 'preload',
			href: cortina_zert,
			as: 'image',
		},
		{
			rel: 'preload',
			href: efes,
			as: 'image',
		},
		{
			rel: 'preload',
			href: esa_bic,
			as: 'image',
		},
		{
			rel: 'preload',
			href: ambersearch_dark,
			as: 'image',
		},
		{
			rel: 'preload',
			href: ambersearch,
			as: 'image',
		},
		{
			rel: 'preload',
			href: pickware,
			as: 'image',
		},
		{
			rel: 'preload',
			href: create_next,
			as: 'image',
		},
		{
			rel: 'preload',
			href: magicline,
			as: 'image',
		},
		{
			rel: 'preload',
			href: magicline_dark,
			as: 'image',
		},
	];
};
